import React from 'react';
import { getNavIconClass } from '../../../../navigation/clinicNavConfig';

const SIZE_CLASS = {
    xs: 'reputation-icon--xs',
    sm: 'reputation-icon--sm',
    md: 'reputation-icon--md',
    lg: 'reputation-icon--lg',
    xl: 'reputation-icon--xl',
};

function ReputationIcon({ icon, theme = 'warning', size = 'md', className = '', round = false, children }) {
    const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.md;

    return (
        <span
            className={`ecx-nav-icon ${getNavIconClass(theme)} reputation-icon ${sizeClass} ${
                round ? 'reputation-icon--round' : ''
            } ${className}`.trim()}
            aria-hidden={children ? undefined : 'true'}
        >
            {icon ? <i className={`bi ${icon}`} /> : null}
            {children}
        </span>
    );
}

export default ReputationIcon;
